import {useNavigate} from 'react-router-dom'
import LoadingBackdrop from '../../components/LoadingBackdrop'
import {useEffect} from 'react'

export default function PublicDecksRedirect() {
  const navigate = useNavigate()

  useEffect(() => {
    navigate('/public-decks')
  }, [])

  return (
    <>
      <LoadingBackdrop loading={true}/>
    </>
  )
}
